export default "__VITE_ASSET__ClUzFTTP__"